import { DateRangePreset } from './daterange-picker.types';

/**
 * Common date range preset utilities
 */

// export const getToday = (): { from: Date; to: Date } => {
//   const today = new Date();
//   today.setHours(0, 0, 0, 0);
//   const endOfDay = new Date(today);
//   endOfDay.setHours(23, 59, 59, 999);
//   return { from: today, to: endOfDay };
// };

export const getToday = (): { from: Date; to: Date } => {
 
  const to = new Date();
  to.setHours(0, 0, 0, 0); // Midnight of today
  
  const from = new Date(to);
  from.setDate(to.getDate() - 1); // Subtract 1 day (yesterday)
  from.setHours(0, 0, 0, 0); // Midnight of yesterday
  
  return { from, to };
};

export const getLastNDays = (day: number): { from: Date; to: Date } => {
 
  const to = new Date();
  
  const from = new Date(to);
  from.setDate(to.getDate() - day );
  from.setHours(0, 0, 0, 0);
  
  return { from, to };
};

export const getThisWeek = (): { from: Date; to: Date } => {
  const today = new Date();
  const dayOfWeek = today.getDay();
  const from = new Date(today);
  from.setDate(today.getDate() - dayOfWeek);
  from.setHours(0, 0, 0, 0);
  
  const to = new Date(from);
  to.setDate(from.getDate() + 6);
  to.setHours(23, 59, 59, 999);
  
  return { from, to };
};

export const getLastWeek = (): { from: Date; to: Date } => {
  const today = new Date();
  const from = new Date(today);
  from.setDate(today.getDate()  - 7);
  from.setHours(0, 0, 0, 0);
  
  const to = today;
  to.setDate(from.getDate() + 6);
  to.setHours(23, 59, 59, 999);
  
  return { from, to };
};

export const getLast6Weeks = (): { from: Date; to: Date } => {
  const to = new Date();
  to.setHours(23, 59, 59, 999);
  
  const from = new Date(to);
  from.setDate(to.getDate() - 42); // 6 weeks = 42 days
  from.setHours(0, 0, 0, 0);
  
  return { from, to };
};

export const getThisMonth = (): { from: Date; to: Date } => {
  const today = new Date();
  const from = new Date(today.getFullYear(), today.getMonth(), 1);
  from.setHours(0, 0, 0, 0);
  
  const to = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  to.setHours(23, 59, 59, 999);
  
  return { from, to };
};

export const getLastMonthFromToday = (): { from: Date; to: Date } => {
  const to = new Date();
  to.setHours(0, 0, 0, 0); 
  
  const from = new Date(to);
  from.setDate(to.getDate() - 30);
  from.setHours(0, 0, 0, 0);
  
  return { from, to };
};

export const getLastMonth = (): { from: Date; to: Date } => {
  const today = new Date();
  const from = new Date(today.getFullYear(), today.getMonth() - 1, 1);
  from.setHours(0, 0, 0, 0);
  
  const to = new Date(today.getFullYear(), today.getMonth(), 0);
  to.setHours(23, 59, 59, 999);
  
  return { from, to };
};

export const getLast6Months = (): { from: Date; to: Date } => {
  const to = new Date();
  to.setHours(23, 59, 59, 999);
  
  const from = new Date(to);
  from.setMonth(to.getMonth() - 6);
  from.setHours(0, 0, 0, 0);
  
  return { from, to };
};

export const getThisYear = (): { from: Date; to: Date } => {
  const today = new Date();
  const from = new Date(today.getFullYear(), 0, 1);
  from.setHours(0, 0, 0, 0);
  
  const to = new Date(today.getFullYear(), 11, 31);
  to.setHours(23, 59, 59, 999);
  
  return { from, to };
};

export const getLastYear = (): { from: Date; to: Date } => {
  const today = new Date();
  const from = new Date(today.getFullYear() - 1, 0, 1);
  from.setHours(0, 0, 0, 0);
  
  const to = new Date(today.getFullYear() - 1, 11, 31);
  to.setHours(23, 59, 59, 999);
  
  return { from, to };
};

/**
 * Common preset configurations
 */

export const commonPresets: DateRangePreset[] = [
  {
    label: 'Today',
    getValue: getToday,
  },
  {
    label: 'This Week',
    getValue: getThisWeek,
  },
  {
    label: 'Last Week',
    getValue: getLastWeek,
  },
  {
    label: 'Last 6 Weeks',
    getValue: getLast6Weeks,
  },
  {
    label: 'This Month',
    getValue: getThisMonth,
  },
  {
    label: 'Last Month',
    getValue: getLastMonth,
  },
  {
    label: 'Last 6 Months',
    getValue: getLast6Months,
  },
  {
    label: 'This Year',
    getValue: getThisYear,
  },
  {
    label: 'Last Year',
    getValue: getLastYear,
  },
];

/**
 * Format date for display
 */
export const formatDateRange = (from: Date, to: Date): string => {
  const options: Intl.DateTimeFormatOptions = { 
    month: 'short', 
    day: 'numeric',
    year: 'numeric'
  };
  
  const fromStr = from.toLocaleDateString('en-US', options);
  const toStr = to.toLocaleDateString('en-US', options);
  
  // If same day, show only once
  if (fromStr === toStr) {
    return fromStr;
  }
  
  return `${fromStr} - ${toStr}`;
};